import axios from "axios";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useContext, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { Link, useLocation } from "react-router-dom";
import { serverInfo } from "../../../App";
import messi from "../../../Assets/Images/messi.jpg";
import Pro from "../../../Assets/Images/no-image.png";
import "../../CSS/Sidebar/Right/Right.css";
// import "./Right/LiveNow/LiveContent.css";
import RightSideSkeliton from "./RightSideSkeliton";
import ReactPlayer from "react-player";
import {useI18n} from "../../../i18n";

export const RightSidebar = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);


  const [learningSession, setLearningSession] = useState([]);
  const [liveChat, setLiveChat] = useState([]);
  const [qna, setQna] = useState([]);
  const [auditionList, setAuditionList] = useState([]);
  const [meetupPhotos, setMeetupPhotos] = useState([]);
  const [liveNow, setLiveNow] = useState([]);
  const [loadingByffer, setLoadingByffer] = useState(true);
  const [greetings, setGreetings] = useState([]);


  //assigning location variable
  const location = useLocation();
  const { pathname } = location;
  const url = pathname.split("/");
  const { t } = useI18n();

  useEffect(() => {

    let isMounted = true
    const fetchEvents = async () => {
      const res = await axios.get("/api/user/all-upcomming-events")
      if (isMounted && res.status === 200) {
        setLoadingByffer(false);
        setLearningSession(res.data.learningSession);
        setLiveChat(res.data.LiveChat);
        setQna(res.data.qna);
        setMeetupPhotos(res.data.meetup);
        setAuditionList(res.data.audition);
        setLiveNow(res.data.liveNow);
        setGreetings(res?.data?.greetings);
      }
    }

    fetchEvents()
    return () => {
      isMounted = false;
  }
  }, [setLoadingByffer,setLearningSession,setLiveChat,setQna,setMeetupPhotos,setAuditionList,setMeetupPhotos,setLiveNow]);


  // <==============================show photos for greetings==========================>

    const GreetingsPhoto = () => {
      return greetings.map((event, i) => (
        <Link key={i} to={`starprofile/${event?.star_id}/greeting`}>
          <div className="container-xc-ds item item-x ">
  
               {event?.video != null ? (
                <>
                  <ReactPlayer
                    url={videoCdnUrl+event?.video}
                    controls={true}
                    autoplay={false}
                    volume={1}
                    height={100}
                    width={150}
                    className="SidebarCarouselImg"
                    style={{ margin: "0 auto" }}
                  />
                </>
              ) : (
                <>
                  <img
                    src={
                      event?.banner !== null
                        ? imageCdnUrl+event?.banner
                        : ''
                    }
                    className="SidebarCarouselImg"
                    alt={event?.banner}
                  />
                </>
              )}
            <div className="bottom-left-c">{event?.title}</div>
          </div>
        </Link>
      ));
    };
  // <==============================show photos for learning session==========================>

  const learningSessionPhoto = () => {
    return learningSession.map((event, i) => (
      <Link key={i} to={`/learning-session/details/${event.id}`}>
        <div className="container-xc-ds item item-x ">

             {event?.video != null ? (
              <>
                <ReactPlayer
                  url={videoCdnUrl+event?.video}
                  controls={true}
                  autoplay={false}
                  volume={1}
                  height={100}
                  width={150}
                  className="SidebarCarouselImg"
                  style={{ margin: "0 auto" }}
                />
              </>
            ) : (
              <>
                <img
                  src={
                    event?.banner !== null
                      ? imageCdnUrl+event?.banner
                      : ''
                  }
                  className="SidebarCarouselImg"
                  alt={event?.banner}
                />
              </>
            )}
          <div className="bottom-left-c">{event?.title}</div>
        </div>
      </Link>
    ));
  };

  //<============================Show LiveChat photos==========================>
  const liveChatPhoto = () => {
    return liveChat.map((event, i) => (
      <Link key={i} to={`/livechat/details/${event.id}`}>
        <div className="container-xc-ds item item-x ">
          <img
            src={imageCdnUrl + event.banner}
            className="SidebarCarouselImg"
            alt="profilePicture"
          />
          <div className="bottom-left-c">{event?.title}</div>
        </div>
      </Link>
    ));
  };
  //<============================Show Qna photos==========================>
  const qnaPhotos = () => {
    return qna?.map((event, i) => (
      <Link key={i} to={`/qna/details/${event.id}`}>
        <div className="container-xc-ds item item-x ">
          <img
            src={imageCdnUrl + event.banner}
            className="SidebarCarouselImg"
            alt="profilePicture"
          />
          <div className="bottom-left-c">{event?.title}</div>
        </div>
      </Link>
    ));
  };

  //<============================Show audition photos==========================>

  const audition = auditionList.map((event, i) => (
      <Link key={i} to={`/audition/registration/${event.id}`}>
        <div className="container-xc-ds item item-x ">
          <img
            src={imageCdnUrl + event.banner}
            className="SidebarCarouselImg"
            alt="profilePicture"
          />
          <div className="bottom-left-c">{event?.title}</div>
        </div>
      </Link>
    ));

  //<============================Show meetup photos==========================>
  const meetupEventPhoto = () => {
    return meetupPhotos.map((event, i) => (
      <Link key={i} to={`/meetup-event/details/${event.id}`}>
        <div className="container-xc-ds item item-x ">
          <img
            src={imageCdnUrl + event.banner}
            className="SidebarCarouselImg"
            alt="profilePicture"
          />
          <div className="bottom-left-c">{event?.title}</div>
        </div>
      </Link>
    ));
  };

    //<============================Show Live Now==========================>
    const liveNowPhotos = () => {
      return liveNow.map((event, i) => (

       <Link key={i} to={`/${event?.event_type == "audition"?("audition/registration/"):(event?.event_type+"/details/")}${event?.id}`}>
          <div className="container-xc-ds item item-x ">
          {event?.video != null ? (
              <>
                <ReactPlayer
                  url={videoCdnUrl+event?.video}
                  controls={true}
                  autoplay={false}
                  volume={1}
                  height={100}
                  width={150}
                  className="SidebarCarouselImg"
                  style={{ margin: "0 auto" }}
                />
              </>
            ) : (
              <>
                <img
                  src={
                    event?.banner !== null
                      ? imageCdnUrl+event?.banner
                      : ''
                  }
                  className="SidebarCarouselImg"
                  alt={event?.banner}
                />
              </>
            )}
            <div className="bottom-left-c">{event?.title}</div>
          </div>
        </Link>
      ));
    };

  return (
    <>
      <div className="LinkBtn">
        {/* Live now */}
        {/* <div className=" xm-mnh-s mt-3">
          <div className="live-text-sln HColor">Live now</div>

          <div className="row ">
            <div className="col-md-10">
              <OwlCarousel
                className="col-md-2"
                items={2}
                loop
                autoplay
                autoplayTimeout={3000}
                margin={0}
                dots={false}
              >
                <div className="container-xc-ds item item-x ">
                  <img
                    src={Pro}
                    className="SidebarCarouselImg"
                    alt="profilePicture"
                  />

                  <div className="top-right-c">🔴</div>
                  <div className="bottom-left-c">Text write</div>
                </div>

                <div className="container-xc-ds item item-x ">
                  <img
                    src={messi}
                    className="SidebarCarouselImg"
                    alt="profilePicture"
                  />

                  <div className="top-right-c">🔴</div>
                  <div className="bottom-left-c">Text write</div>
                </div>
              </OwlCarousel>
            </div>

            <Link to="/live-now" className="col-md-2  item-xx-l mt-3 ">
              <button
                className={
                  url[1] === "live-now"
                    ? "btn right-btn-side-active"
                    : "btn right-btn-side"
                }
              >
                <small className=" H-text">See All</small>
                <i className="fas fa-arrow-alt-circle-down  H-text "></i>
              </button>
            </Link>
          </div>
        </div>
 */}

        {loadingByffer ? (
          <RightSideSkeliton />
        ) : (
          <>
            {liveNow.length > 0 && (
              <div className=" xm-mnh-s mt-3">
                <div className="live-text-sln HColor">{t('Live_Now_text')}</div>

                <div className="row ">
                  <div className="col-md-10">
                    <OwlCarousel
                      className="col-md-2"
                      items={2}
                      // loop
                      autoplay
                      autoplayTimeout={3500}
                      margin={0}
                      dots={false}
                    >
                      {liveNowPhotos()}
                    </OwlCarousel>
                  </div>
                </div>
              </div>
            )}
          </>
        )}


        {/* Greetings */}
        {loadingByffer ? (
          <RightSideSkeliton />
        ) : (
          <>
            {greetings?.length > 0 && (
              <div className=" xm-mnh-s mt-3">
                <div className="live-text-sln HColor">{t('Greetings_text')}</div>

                <div className="row ">
                  <div className="col-md-10">
                    <OwlCarousel
                      className="col-md-2"
                      items={2}
                      // loop
                      autoplay
                      autoplayTimeout={3500}
                      margin={0}
                      dots={false}
                    >
                      {GreetingsPhoto()}
                    </OwlCarousel>
                  </div>

                  <Link
                    to={
                      localStorage.getItem("auth_token")
                        ? `/upcoming-greetings`
                        : `/guest_mode/upcoming-greetings`
                    }
                    // to={`/guest_mode/upcoming-learning-sessions`}
                    className="col-md-2  item-xx-l mt-3 "
                  >
                    <button
                      className={
                        url[1] === "upcoming-greetings" ||
                          url[1] === "guest_mode/upcoming-greetings"
                          ? "btn right-btn-side-active right-btn-width"
                          : "btn right-btn-side right-btn-width"
                      }
                    >
                      <small className=" H-text">{t('See_More_Text')}</small>
                      <i className="fas fa-arrow-alt-circle-down  H-text "></i>
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </>
        )}

        {/* Learning Session */}

        {loadingByffer ? (
          <RightSideSkeliton />
        ) : (
          <>
            {learningSession.length > 0 && (
              <div className=" xm-mnh-s mt-3">
                <div className="live-text-sln HColor">{t('Learning_Sessions_text')}</div>

                <div className="row ">
                  <div className="col-md-10">
                    <OwlCarousel
                      className="col-md-2"
                      items={2}
                      // loop
                      autoplay
                      autoplayTimeout={3500}
                      margin={0}
                      dots={false}
                    >
                      {learningSessionPhoto()}
                    </OwlCarousel>
                  </div>

                  <Link
                    to={
                      localStorage.getItem("auth_token")
                        ? `/upcoming-learning-sessions`
                        : `/guest_mode/upcoming-learning-sessions`
                    }
                    // to={`/guest_mode/upcoming-learning-sessions`}
                    className="col-md-2  item-xx-l mt-3 "
                  >
                    <button
                      className={
                        url[1] === "upcoming-learning-sessions" ||
                          url[1] === "guest_mode/upcoming-learning-sessions"
                          ? "btn right-btn-side-active right-btn-width"
                          : "btn right-btn-side right-btn-width"
                      }
                    >
                      <small className=" H-text">{t('See_More_Text')}</small>
                      <i className="fas fa-arrow-alt-circle-down  H-text "></i>
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </>
        )}

        {/*Upcoming Live Chat*/}
        {loadingByffer ? (
          <RightSideSkeliton />
        ) : (
          <>
            {liveChat.length > 0 && (
              <div className=" xm-mnh-s mt-3">
                <div className="live-text-sln HColor">{t('Live_Chat_Text')}</div>

                <div className="row ">
                  <div className="col-md-10">
                    <OwlCarousel
                      className="col-md-2"
                      items={2}
                      // loop
                      autoplay
                      autoplayTimeout={4000}
                      margin={0}
                      dots={false}
                    >
                      {liveChatPhoto()}
                    </OwlCarousel>
                  </div>

                  <Link
                    to="/upcoming-live-chat"
                    className="col-md-2  item-xx-l mt-3 "
                  >
                    <button
                      className={
                        url[1] === "upcoming-live-chat"
                          ? "btn right-btn-side-active right-btn-width"
                          : "btn right-btn-side right-btn-width"
                      }
                    >
                      <small className=" H-text">{t('See_More_Text')}</small>
                      <i className="fas fa-arrow-alt-circle-down  H-text "></i>
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </>
        )}

        {/*Upcoming Auditions */}
        {loadingByffer ? (
          <RightSideSkeliton />
        ) : (
          <>
            {auditionList.length > 0 && (
              <div className=" xm-mnh-s mt-3">
                <div className="live-text-sln HColor">{t('Upcoming_Audition_Text')}</div>

                <div className="row ">
                  <div className="col-md-10">
                   <OwlCarousel
                      className="col-md-2"
                      items={2}
                      //loop
                      autoplay
                      autoplayTimeout={4000}
                      margin={0}
                      dots={false}
                    >
                      {audition}
                    </OwlCarousel>
                  </div>

                  <Link
                    to="/upcoming-auditions"
                    className="col-md-2  item-xx-l mt-3 "
                  >
                    {audition.length>1 && <button
                      className={
                        url[1] === "upcoming-auditions"
                          ? "btn right-btn-side-active right-btn-width"
                          : "btn right-btn-side right-btn-width"
                      }
                    >
                      <small className=" H-text">{t('See_More_Text')}</small>
                      <i className="fas fa-arrow-alt-circle-down  H-text "></i>
                    </button>}
                  </Link>
                </div>
              </div>
            )}
          </>
        )}

        {/*Meetup Events */}
        {loadingByffer ? (
          <RightSideSkeliton />
        ) : (
          <>
            {meetupPhotos.length > 0 && (
              <div className=" xm-mnh-s mt-3">
                <div className="live-text-sln HColor">{t('Meetup_Events_Text')}</div>

                <div className="row ">
                  <div className="col-md-10">
                    <OwlCarousel
                      className="col-md-2"
                      items={2}
                      // loop
                      autoplay
                      autoplayTimeout={1500}
                      margin={0}
                      dots={false}
                    >
                      {meetupEventPhoto()}
                    </OwlCarousel>
                  </div>

                  <Link
                    to="/upcoming-meetup-events"
                    className="col-md-2  item-xx-l mt-3 "
                  >
                    <button
                      className={
                        url[1] === "upcoming-meetup-events"
                          ? "btn right-btn-side-active right-btn-width"
                          : "btn right-btn-side right-btn-width"
                      }
                    >
                      <small className=" H-text">{t('See_More_Text')}</small>
                      <i className="fas fa-arrow-alt-circle-down  H-text "></i>
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </>
        )}

        {/*Question $ Answer */}
        {loadingByffer ? (
          <RightSideSkeliton />
        ) : (
          <>
            {qna.length > 0 && (
              <div className=" xm-mnh-s mt-3">
                <div className="live-text-sln HColor">{t('Question_Answer_Text')}</div>

                <div className="row ">
                  <div className="col-md-10">
                    <OwlCarousel
                      className="col-md-2"
                      items={2}
                      // loop
                      autoplay
                      autoplayTimeout={1500}
                      margin={0}
                      dots={false}
                    >
                      {qnaPhotos()}
                    </OwlCarousel>
                  </div>

                  <Link
                    to="/upcoming-qna-events"
                    className="col-md-2  item-xx-l mt-3 "
                  >
                    <button
                      className={
                        url[1] === "upcoming-qna-events"
                          ? "btn right-btn-side-active right-btn-width"
                          : "btn right-btn-side right-btn-width"
                      }
                    >
                      <small className=" H-text">{t('See_More_Text')}</small>
                      <i className="fas fa-arrow-alt-circle-down  H-text "></i>
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </>
        )}
        {/*Question $ Answer */}
        {/* {loadingByffer ? (
          <RightSideSkeliton />
        ) : (
          <>
            {qna.length > 0 && (
              <div className=" xm-mnh-s mt-3">
                <div className="live-text-sln HColor">Greetings</div>

                <div className="row ">
                  <div className="col-md-10">
                    <OwlCarousel
                      className="col-md-2"
                      items={2}
                      loop
                      autoplay
                      autoplayTimeout={1500}
                      margin={0}
                      dots={false}
                    >
                      {qnaPhotos()}
                    </OwlCarousel>
                  </div>

                  <Link
                    to="/upcoming-qna-events"
                    className="col-md-2  item-xx-l mt-3 "
                  >
                    <button
                      className={
                        url[1] === "upcoming-qna-events"
                          ? "btn right-btn-side-active"
                          : "btn right-btn-side"
                      }
                    >
                      <small className=" H-text">See All</small>
                      <i className="fas fa-arrow-alt-circle-down  H-text "></i>
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </>
        )} */}
      </div>
    </>
  );
};
export default RightSidebar;
